<template lang="pug">
  .chain-module
    h3.tp-m-deci {{ this.$t('dashboard.chains') }}
    .card-container
      chain-card(
        v-for="cadenaComercial in this.lCommerce"
        :data="cadenaComercial"
        :key="cadenaComercial.codcadenal")

</template>

<script>
import ChainCard from '@/components/cadena/ChainCard'
import { mapGetters } from 'vuex'

export default {
  name: 'ChainModule',

  components: {
    ChainCard
  },

  data () {
    return {
    }
  },

  computed: {
    ...mapGetters([
      'getListCommerceData'
    ]),

    lCommerce () {
      let datosComerce = []
      if (this.getListCommerceData !== undefined) {
        if (this.getListCommerceData !== '') {
          datosComerce = this.getListCommerceData
        }
      }
      return datosComerce
    }
  }
}
</script>

<style lang='scss' scoped>
.card-container {
    display: flex;
    align-content: space-between;
    flex-wrap: wrap;
}

.chain-module {
  margin-bottom: rem(24)
}
</style>
